import { Skeleton } from "@/components/ui/skeleton"
import { ProductCardSkeleton } from "../../../shared/product-card/skeleton"

const RELATED_PRODUCTS_COUNT = 4

export const RelatedProductsSkeleton = () => {
  return (
    <div className='space-y-4'>
      <Skeleton className='h-7 w-48' />

      <div className='flex gap-4'>
        {Array.from({ length: RELATED_PRODUCTS_COUNT }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <list> Skeleton only
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    </div>
  )
}
